import { useContext, useEffect, useState } from "react";
import { Menu } from "@material-ui/core";
import { useUpdatePinnedLog } from "utils/hooks/apiHooks/notes-feature/useUpdatePinnedLog";
import { PinnedLogsContext } from "components/AllLogHistoryNew";
import DFMenuItem from "components/DFCustoms/DFMenuItem";
import DFNotePin from "components/DFIcons/DFNotePin";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

export default function NoteItemMenu({
  logId,
  callType,
  isPinned,
  anchorEl,
  closeModal,
  openDetails,
  additionalMenuItems,
}: {
  logId: string;
  callType: "web_form_log" | "chat_widget" | "sms_log" | "call_log" | "note";
  isPinned: boolean;
  anchorEl: any;
  closeModal: () => void;
  openDetails: () => void;
  additionalMenuItems?: any[];
}) {
  const [innerIsPinned, setInnerIsPinned] = useState<boolean>();
  useEffect(() => {
    setInnerIsPinned(isPinned);
  }, [isPinned]);

  const [updatePinnedStatus] = useUpdatePinnedLog(() => {
    setInnerIsPinned(!innerIsPinned);
  });
  return (
    <>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(event: any) => {
          closeModal();
          event.stopPropagation();
        }}
      >
        <DFMenuItem
          onClick={(event: any) => {
            closeModal();
            updatePinnedStatus({
              logId: logId,
              callType: callType,
              isPinned: !innerIsPinned,
            });
            event.stopPropagation();
          }}
          icon={<DFNotePin isPinned />}
          text={innerIsPinned ? "Unpin" : "Pin to top"}
        />

        {callType !== "note" && (
          <DFMenuItem
            onClick={() => {
              openDetails();
              closeModal();
            }}
            icon={<VisibilityIcon />}
            text={"View Details"}
          />
        )}

        {additionalMenuItems?.length >= 1 &&
          additionalMenuItems?.map((item) => item)}
      </Menu>
    </>
  );
}
